// LeadDiscardReasonDialog — обязательный выбор причины перед PATCH лида в DISCARDED (V16 W5).

import { ReasonSelectDialog } from '@/components/ReasonSelectDialog';
import { t } from '@/i18n';

/** Пропсы диалога причины отказа при переходе лида в DISCARDED. */
export interface LeadDiscardReasonDialogProps {
  /** Открыт ли диалог. */
  open: boolean;
  /** Закрытие без PATCH (отмена; статус в форме откатывается владельцем). */
  onClose: () => void;
  /** Подтверждение: выбранный id причины; PATCH делает владелец (LeadDetailPage). */
  onConfirm: (rejectionReasonId: string) => void;
  /** Мутация лида в полёте — блокирует повторный submit. */
  pending?: boolean;
}

/**
 * Диалог выбора причины отказа перед переводом лида в DISCARDED.
 * Каталог — GET /api/rejection-reasons; без OK PATCH не уходит.
 */
export function LeadDiscardReasonDialog(props: LeadDiscardReasonDialogProps): JSX.Element {
  return (
    <ReasonSelectDialog
      {...props}
      titleId="lead-discard-reason-title"
      title={t('leads.discardReason.title')}
      label={t('leads.discardReason.label')}
      confirmLabel={t('leads.discardReason.confirm')}
      loadError={t('leads.discardReason.loadError')}
      cancelLabel={t('common.cancel')}
    />
  );
}
